import secureLocalStorage from "react-secure-storage";

export const getDefaultStringValue = (key: string): string => {
    return (secureLocalStorage.getItem(key) ?? '') as string;
};

export const getDefaultBooleanValue = (key: string): boolean => {
    return (secureLocalStorage.getItem(key) ?? false) as boolean;
};

export const getDefaultEmptyListValue = (key: string): string[] => {
    return (secureLocalStorage.getItem(key) ?? []) as string[];
};